import Cookies from 'js-cookie';
import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.ArchiveFilters;

// initial state
// object name must match specification name
const filters = {
    searchTerm: new FormControl.FilterGroup(
        'SearchTerm', 'Search by Keyword', null, null, false, true, 'textbox',
        new FormControl.Textbox('Search')
    ), 
    
};

if (CONST.globalProject.ArchiveFilters) {
    const startsWith = CONST.globalProject.ArchiveFilters.find(x => x.Specification === 'StartsWith');
    if (startsWith != null) {
        filters.StartsWith = new FormControl.FilterGroup(
            'StartsWith', 'Starts With', null, null, false, true, 'custom',
            new FormControl.Textbox('')
        );
    }
    const stateCode = CONST.globalProject.ArchiveFilters.find(x => x.Specification === 'StateCode');
    if (stateCode != null) {
        filters.StateCode = new FormControl.FilterGroup('StateCode', 'State', 'All States', Cookies.get('StateCode'), false, true, 'select');
    }
}

FormControl.assignFilters(filterObj, filters);

export { filters as default };